export enum ERouteName {
	'AcceptTOS' = 'AcceptTOS',
	'AccountDelete' = 'AccountDelete',
	'History' = 'History',
	'Home' = 'Home',
	'Launch' = 'Launch',
	'Locations' = 'Locations',
	'Login' = 'Login',
	'Map' = 'Map',
	'Menu' = 'Menu',
	'MenuCategory' = 'MenuCategory',
	'MenuItem' = 'MenuItem',
	'Profile' = 'Profile',
	'Reward' = 'Reward',
	'Scan' = 'Scan',
	'VisitDetail' = 'VisitDetail',
	'Order' = 'Order',
	'QRCode' = 'QRCode',
	'ThankYou' = 'ThankYou',
	'OrderTracker' = 'OrderTracker',
	'Share' = 'Share',
	'UnclaimedReward' = 'UnclaimedReward',
	'UnclaimedNPS' = 'UnclaimedNPS'
}

export const ORDER_ROUTES = [
	ERouteName.Order,
	ERouteName.MenuItem,
	ERouteName.ThankYou,
	ERouteName.MenuCategory
];
